export class Empenho {

  codigoProjeto: string;
  anoExercicio: number;
  codigoCredor: number;
  nomeCredor: string;
  cnpjCpfCredor: string;
  numeroEmpenho: string;
  valorEmpenho: number;
  NumPedEmp: string;
  numeroProcessoSEI: string;
  mensagemErro: string;
  reenviado: boolean;

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/models/pagamento/empenho.ts